import { SelectOption, SelectOptionsCollection } from 'shared/models/SelectOption';
import { ECompanyType } from 'shared/repositories/coworking/entities/api/PublicationRequestSchema';

export const companyTypeSelectOptions: SelectOptionsCollection<ECompanyType> = [
  new SelectOption('Брокер', ECompanyType.Broker),
  new SelectOption('Собственник бизнес-центра', ECompanyType.BusinessCenterOwner),
  new SelectOption('Управляющая компания', ECompanyType.ManagementCompany),
  new SelectOption('Оператор коворкинга', ECompanyType.Operator),
];
